var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  strokeWidth: 1.5,
  d: "M9.57 6.43 3.5 12.5l6.07 6.07"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  strokeMiterlimit: 10,
  d: "M20.502 12.5H3.672"
})));
export { SvgLeftArrow as ReactComponent };
export default __webpack_public_path__ + "748aa3ca96be8fc637a93fb70925c0cf.svg";